/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    value: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    glowing: PropTypes.bool,
    color: PropTypes.oneOf(['default', 'light', 'danger']),
};

const defaultProps = {
    ...commonDefaultProps,
    loading: false,
    glowing: false,
    color: 'default',
};

const ProgressBar = (props) => {
    const classNames = [
        'c-progress-bar',
        props.loading ? 'c-progress-bar__progress--loading' : '',
        props.glowing ? 'c-progress-bar__progress--glowing' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    const style = {
        width: `${props.value}%`,
    };
    const contentClassName = `c-progress-bar__progress c-progress-bar__progress--${props.color}`;
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            <div
                className={contentClassName}
                style={style}
            />
        </props.componentClass>
    );
};

ProgressBar.propTypes = propTypes;

ProgressBar.defaultProps = defaultProps;

export default ProgressBar;
